module.exports = __webpack_public_path__ + "img/home_active.316ab98c.png";